import { render, staticRenderFns } from "./tab_medkon.vue?vue&type=template&id=36e14bd1&"
import script from "./tab_medkon.vue?vue&type=script&lang=js&"
export * from "./tab_medkon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports